// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KYU5t2u5AOPO9WhgYPT_ {

    margin-left: 3rem;

    display: flex;

    flex-direction: column;

    padding-bottom: 1.5rem
}

.q087sgq2eKOsREo4hawg {

    margin-bottom: 2.25rem;

    display: flex;

    justify-content: space-between
}

.K0TttkuZGHVbJAYt3AMt {

    --tw-border-opacity: 1 !important;

    border-color: rgb(228 229 231 / var(--tw-border-opacity, 1)) !important;

    font-family: Noto Sans;

    font-size: 1.125rem;

    line-height: 1.75rem;

    font-weight: 700;

    font-weight: 17px
}

.jmGCoPmehrgtRxQEb2GX {

    height: 38px !important;

    width: 39px !important;

    --tw-bg-opacity: 1 !important;

    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important
}

.KrSyUb98XRLL1AbSy17Y {

    display: flex;

    flex-wrap: wrap;

    row-gap: 1.25rem
}

.ZgTHtcKEKrmCgCeRZUFA {

    height: auto;

    width: 45%
}

.FAmWgzIYqC_9EN1M9DFv {

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-weight: 400;

    --tw-text-opacity: 1;

    color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}

.wVA59ffbYcZY3ofzCubM {

    margin-top: 0.5rem;

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-weight: 500
}
`, "",{"version":3,"sources":["webpack://./src/components/Account/PersonalInformation/PersonalInformation.module.css"],"names":[],"mappings":"AACE;;IAAA,iBAA+B;;IAA/B,aAA+B;;IAA/B,sBAA+B;;IAA/B;AAA+B;;AAI/B;;IAAA,sBAAgC;;IAAhC,aAAgC;;IAAhC;AAAgC;;AAIhC;;IAAA,iCAAoE;;IAApE,uEAAoE;;IAApE,sBAAoE;;IAApE,mBAAoE;;IAApE,oBAAoE;;IAApE,gBAAoE;;IAApE;AAAoE;;AAIpE;;IAAA,uBAAkD;;IAAlD,sBAAkD;;IAAlD,6BAAkD;;IAAlD;AAAkD;;AAIlD;;IAAA,aAA6B;;IAA7B,eAA6B;;IAA7B;AAA6B;;AAI7B;;IAAA,YAAqB;;IAArB;AAAqB;;AAIrB;;IAAA,mBAAwC;;IAAxC,oBAAwC;;IAAxC,gBAAwC;;IAAxC,oBAAwC;;IAAxC;AAAwC;;AAIxC;;IAAA,kBAA+B;;IAA/B,mBAA+B;;IAA/B,oBAA+B;;IAA/B;AAA+B","sourcesContent":[".mainContainer {\n  @apply flex flex-col ml-12 pb-6;\n}\n\n.headingSection {\n  @apply flex justify-between mb-9;\n}\n\n.headingText {\n  @apply text-lg font-bold font-inter font-[17px] !border-dividerColor;\n}\n\n.editButton {\n  @apply !bg-activeMenuItemColor !h-[38px] !w-[39px];\n}\n\n.personalInfoSection {\n  @apply flex flex-wrap gap-y-5;\n}\n\n.singleInfoWrapper {\n  @apply w-[45%] h-auto;\n}\n\n.infoTitle {\n  @apply text-sm font-normal text-gray-400;\n}\n\n.info {\n  @apply text-sm font-medium mt-2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `KYU5t2u5AOPO9WhgYPT_`,
	"headingSection": `q087sgq2eKOsREo4hawg`,
	"headingText": `K0TttkuZGHVbJAYt3AMt`,
	"editButton": `jmGCoPmehrgtRxQEb2GX`,
	"personalInfoSection": `KrSyUb98XRLL1AbSy17Y`,
	"singleInfoWrapper": `ZgTHtcKEKrmCgCeRZUFA`,
	"infoTitle": `FAmWgzIYqC_9EN1M9DFv`,
	"info": `wVA59ffbYcZY3ofzCubM`
};
export default ___CSS_LOADER_EXPORT___;
